import styled from 'styled-components';

export default styled.header`
  display: flex;
  justify-content: space-between;
  padding: 0 0 16px;
  border-bottom: 1px solid #eee;
  align-items: center;
`;
